import { createSlice } from "@reduxjs/toolkit";

const THEME_KEY = "ebmr.theme";
const SIDER_KEY = "ebmr.sider";
const FONT_KEY = "ebmr.fontScale";
const LANG_KEY = "ebmr.lang";

/** Presentation preferences that persist per browser, as the old UI did. */
const slice = createSlice({
  name: "ui",
  initialState: {
    theme: localStorage.getItem(THEME_KEY) || "light",
    siderCollapsed: localStorage.getItem(SIDER_KEY) === "true",
    fontScale: localStorage.getItem(FONT_KEY) || "md",
    lang: localStorage.getItem(LANG_KEY) || "en",
  },
  reducers: {
    toggleTheme(state) {
      state.theme = state.theme === "light" ? "dark" : "light";
      localStorage.setItem(THEME_KEY, state.theme);
      document.documentElement.dataset.theme = state.theme;
    },
    setTheme(state, action) {
      state.theme = action.payload;
      localStorage.setItem(THEME_KEY, state.theme);
      document.documentElement.dataset.theme = state.theme;
    },
    toggleSider(state) {
      state.siderCollapsed = !state.siderCollapsed;
      localStorage.setItem(SIDER_KEY, String(state.siderCollapsed));
    },
    /** sm | md | lg | xl — read off <html> by the scale rules in index.css. */
    setFontScale(state, action) {
      state.fontScale = action.payload;
      localStorage.setItem(FONT_KEY, state.fontScale);
      document.documentElement.dataset.fontScale = state.fontScale;
    },
    setLang(state, action) {
      state.lang = action.payload;
      localStorage.setItem(LANG_KEY, state.lang);
      document.documentElement.lang = state.lang;
    },
  },
});

export const { toggleTheme, setTheme, toggleSider, setFontScale, setLang } =
  slice.actions;
export default slice.reducer;

export const selectTheme = (state) => state.ui.theme;
export const selectSiderCollapsed = (state) => state.ui.siderCollapsed;
export const selectFontScale = (state) => state.ui.fontScale;
export const selectLang = (state) => state.ui.lang;
